/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkManualExportDto } from '../models/BulkManualExportDto';
import type { BulkReleaseApiResponse } from '../models/BulkReleaseApiResponse';
import type { BulkReleasePayoutsDto } from '../models/BulkReleasePayoutsDto';
import type { FetchPayoutsApiResponse } from '../models/FetchPayoutsApiResponse';
import type { GeneratePayoutsApiResponse } from '../models/GeneratePayoutsApiResponse';
import type { GeneratePayoutsDto } from '../models/GeneratePayoutsDto';
import type { HoldPayoutDto } from '../models/HoldPayoutDto';
import type { MarkBankFailedDto } from '../models/MarkBankFailedDto';
import type { MarkBankSettledDto } from '../models/MarkBankSettledDto';
import type { PayoutActionApiResponse } from '../models/PayoutActionApiResponse';
import type { PayoutDetailApiResponse } from '../models/PayoutDetailApiResponse';
import type { PayoutSettingsApiResponse } from '../models/PayoutSettingsApiResponse';
import type { PayoutSummaryApiResponse } from '../models/PayoutSummaryApiResponse';
import type { UpdatePayoutSettingsDto } from '../models/UpdatePayoutSettingsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminPayoutsService {
    /**
     * List payouts
     * Retrieve a paginated list of expert payouts with search and filters by status and month.
     * @param expertId Filter by expert UUID (e.g. for expert detail page)
     * @param search Free text search over payout number or expert name
     * @param statuses Filter by one or more payout statuses
     * @param serviceId Filter by service type UUID
     * @param payoutMonth Filter by payout month (YYYY-MM format)
     * @param payoutMethod Filter by payout rail.
     * @param country Filter by expert country (ISO-3166 alpha-2, e.g. AE or IN).
     * @param dateFrom Filter payouts created on/after this date (ISO 8601)
     * @param dateTo Filter payouts created on/before this date (ISO 8601)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns FetchPayoutsApiResponse Payouts fetched successfully
     * @throws ApiError
     */
    public static adminPayoutsControllerFetchPayoutsV1(
        expertId?: string,
        search?: string,
        statuses?: Array<'pending' | 'on_hold' | 'released' | 'manual_released' | 'paid' | 'bank_settled' | 'failed'>,
        serviceId?: string,
        payoutMonth?: string,
        payoutMethod?: 'stripe_connect' | 'manual_bank',
        country?: string,
        dateFrom?: string,
        dateTo?: string,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<FetchPayoutsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/payouts',
            query: {
                'expertId': expertId,
                'search': search,
                'statuses': statuses,
                'serviceId': serviceId,
                'payoutMonth': payoutMonth,
                'payoutMethod': payoutMethod,
                'country': country,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'page': page,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Get payout summary stats
     * Get aggregated stats: current month totals, active disputes, and previous month paid totals.
     * @param payoutMonth Month in YYYY-MM format (defaults to current month)
     * @returns PayoutSummaryApiResponse Summary retrieved
     * @throws ApiError
     */
    public static adminPayoutsControllerGetPayoutSummaryV1(
        payoutMonth?: string,
    ): CancelablePromise<PayoutSummaryApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/payouts/summary',
            query: {
                'payoutMonth': payoutMonth,
            },
        });
    }
    /**
     * Get payout configuration
     * Get the current payout settings (automation flag and payout day).
     * @returns PayoutSettingsApiResponse Settings retrieved
     * @throws ApiError
     */
    public static adminPayoutsControllerGetPayoutSettingsV1(): CancelablePromise<PayoutSettingsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/payouts/settings',
        });
    }
    /**
     * Update payout configuration
     * Update payout automation settings.
     * @param requestBody
     * @returns PayoutSettingsApiResponse Settings updated
     * @throws ApiError
     */
    public static adminPayoutsControllerUpdatePayoutSettingsV1(
        requestBody: UpdatePayoutSettingsDto,
    ): CancelablePromise<PayoutSettingsApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/payouts/settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Download payout report
     * Download a CSV report of all payouts for a given month.
     * @param payoutMonth Month in YYYY-MM format
     * @returns any CSV file downloaded
     * @throws ApiError
     */
    public static adminPayoutsControllerDownloadReportV1(
        payoutMonth: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/payouts/report',
            query: {
                'payoutMonth': payoutMonth,
            },
        });
    }
    /**
     * Bulk export pending manual-bank payouts as CSV
     * Builds a bank-ready CSV (ENBD / FAB / MASHREQ / GENERIC) for pending manual payouts in the given month. Experts without bank details are skipped (stay pending) and listed in `skipped`. Included rows are marked manual_released.
     * @param requestBody
     * @returns any CSV payload and skip list returned
     * @throws ApiError
     */
    public static adminPayoutsControllerBulkExportManualPayoutsV1(
        requestBody: BulkManualExportDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/payouts/manual/bulk-export',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Bulk mark manual payouts as bank-settled
     * After the corporate banking portal confirms a batch transfer, mark each released manual-bank payout as bank_settled with its bank reference number. Atomic per-row transition; concurrent calls are race-safe and idempotent on already-settled rows.
     * @param requestBody
     * @returns any Settlement counts returned
     * @throws ApiError
     */
    public static adminPayoutsControllerMarkBankSettledV1(
        requestBody: MarkBankSettledDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/payouts/manual/mark-bank-settled',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate payouts for a month
     * Calculate and create payout records for all experts with completed sessions in the given month.
     * @param requestBody
     * @returns GeneratePayoutsApiResponse Payouts generated
     * @throws ApiError
     */
    public static adminPayoutsControllerGeneratePayoutsV1(
        requestBody: GeneratePayoutsDto,
    ): CancelablePromise<GeneratePayoutsApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/payouts/generate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Payouts already exist for this month or no sessions found`,
            },
        });
    }
    /**
     * Bulk release payouts
     * Release all eligible (pending) payouts for a given month.
     * @param requestBody
     * @returns BulkReleaseApiResponse Bulk release completed
     * @throws ApiError
     */
    public static adminPayoutsControllerBulkReleaseV1(
        requestBody: BulkReleasePayoutsDto,
    ): CancelablePromise<BulkReleaseApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/payouts/bulk-release',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid month format`,
            },
        });
    }
    /**
     * Get payout detail
     * Get full payout detail including expert info, transaction line items, and deductions.
     * @param id Payout UUID or payout number
     * @returns PayoutDetailApiResponse Payout detail retrieved
     * @throws ApiError
     */
    public static adminPayoutsControllerGetPayoutDetailV1(
        id: string,
    ): CancelablePromise<PayoutDetailApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/payouts/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Payout not found`,
            },
        });
    }
    /**
     * Place payout on hold
     * Place a pending payout on hold with a reason.
     * @param id Payout UUID or payout number
     * @param requestBody
     * @returns PayoutActionApiResponse Payout placed on hold
     * @throws ApiError
     */
    public static adminPayoutsControllerHoldPayoutV1(
        id: string,
        requestBody: HoldPayoutDto,
    ): CancelablePromise<PayoutActionApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/payouts/{id}/hold',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid payout status for hold`,
                404: `Payout not found`,
            },
        });
    }
    /**
     * Resume payout from hold
     * Move an on-hold payout back to pending status so it can be released later.
     * @param id Payout UUID or payout number
     * @returns PayoutActionApiResponse Payout resumed to pending
     * @throws ApiError
     */
    public static adminPayoutsControllerUnholdPayoutV1(
        id: string,
    ): CancelablePromise<PayoutActionApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/payouts/{id}/unhold',
            path: {
                'id': id,
            },
            errors: {
                400: `Payout is not on hold`,
                404: `Payout not found`,
            },
        });
    }
    /**
     * Release payout
     * Release a pending or on-hold payout for payment.
     * @param id Payout UUID or payout number
     * @returns PayoutActionApiResponse Payout released
     * @throws ApiError
     */
    public static adminPayoutsControllerReleasePayoutV1(
        id: string,
    ): CancelablePromise<PayoutActionApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/payouts/{id}/release',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid payout status for release`,
                404: `Payout not found`,
            },
        });
    }
    /**
     * Mark payout as paid
     * Mark a released payout as paid with an optional external transaction reference.
     * @param id Payout UUID or payout number
     * @returns PayoutActionApiResponse Payout marked as paid
     * @throws ApiError
     */
    public static adminPayoutsControllerMarkPaidV1(
        id: string,
    ): CancelablePromise<PayoutActionApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/payouts/{id}/mark-paid',
            path: {
                'id': id,
            },
            errors: {
                400: `Payout must be released before marking as paid`,
                404: `Payout not found`,
            },
        });
    }
    /**
     * Mark manual payout as bank-failed
     * Mark a single manual-bank payout as failed when the bank rejects the transfer. Records the failure reason; payout can be retried after the underlying issue is fixed.
     * @param id Payout UUID
     * @param requestBody
     * @returns PayoutActionApiResponse Payout marked as bank-failed
     * @throws ApiError
     */
    public static adminPayoutsControllerMarkBankFailedV1(
        id: string,
        requestBody: MarkBankFailedDto,
    ): CancelablePromise<PayoutActionApiResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/admin/payouts/{id}/mark-bank-failed',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Payout is not a manual-bank payout`,
                404: `Payout not found`,
            },
        });
    }
}
